import * as React from 'react';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {DatePickerWrapper, InputErrorMessage} from './DatePickerStyle';
import {DatePicker} from '@mui/x-date-pickers';
import {TextField} from '@mui/material';
import dayjs from 'dayjs';

interface BasicDatePickerProps {
  label: string;
  handleChange?: (e: any) => void;
  // eslint-disable-next-line react/boolean-prop-naming
  error: boolean;
  helperText?: string;
  field?: any;
  // eslint-disable-next-line react/boolean-prop-naming
  monthYearFormatView?: boolean;
  yearFormatView?: any;
  minDate?: any;
  value?: any;
  sx?: object;
  disabled?: any;
}

interface RenderInputParams {
  label?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  inputProps: {
    placeholder?: string;
  };
}

export default function BasicDatePicker(
  props: BasicDatePickerProps
): React.ReactElement {
  const {
    label,
    error,
    helperText,
    field,
    monthYearFormatView,
    handleChange,
    yearFormatView,
    minDate,
    value = null,
    disabled,
    sx = {}
  } = props;

  const getValue = () => {
    if (field?.value) {
      return dayjs(field.value).isValid() ? dayjs(field.value) : null; // Ensure valid Day.js object
    }
    return null;
  };

  const getViewValue = () => {
    if (yearFormatView) {
      return ['year'];
    } else if (monthYearFormatView) {
      return ['year', 'month'];
    } else {
      return ['year', 'month', 'day'];
    }
  };

  const getFormat = () => {
    if (yearFormatView) {
      return 'YYYY';
    } else if (monthYearFormatView) {
      return 'YYYY-MM';
    } else {
      return 'MM/DD/YYYY';
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePickerWrapper>
        <DatePicker
          disabled={disabled}
          label={label}
          disableFuture
          minDate={minDate}
          defaultValue={null}
          views={getViewValue()}
          {...field}
          value={value ?? getValue()}
          onChange={e => {
            field.onChange(e);
            if (handleChange) handleChange(e);
          }}
          format={getFormat()}
          renderInput={(params: RenderInputParams) => (
            <TextField
              placeholder="Enter Date"
              {...params}
              inputProps={{
                ...params.inputProps,
                placeholder: 'Enter Date'
              }}
            />
          )}
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#0000003b',
              borderWidth: '1.8px'
            },
            ...sx
          }}
        />
      </DatePickerWrapper>
      {error && <InputErrorMessage>{helperText}</InputErrorMessage>}
    </LocalizationProvider>
  );
}
